{
	"title": "Officials",
	"subtitle": "Technical officials of {{games}}: approved cards in the Technical Official category. Click a row to see their meets.",
	"gender": {
		"MALE": "Male",
		"FEMALE": "Female",
		"unknown": "Not given"
	},
	"role": {
		"REFEREE": "Referee",
		"UMPIRE": "Umpire",
		"JUDGE": "Judge",
		"STARTER": "Starter",
		"TIMEKEEPER": "Timekeeper",
		"TECHNICAL_DELEGATE": "Technical delegate",
		"COACH": "Coach",
		"MANAGER": "Manager",
		"OTHER": "Official"
	},
	"filters": {
		"label": "Filter the officials",
		"name": "Name or card number",
		"noc": "NOC",
		"allNocs": "All NOCs",
		"sport": "Sport",
		"allSports": "All sports"
	},
	"table": {
		"official": "Official",
		"card": "Card no.",
		"noc": "NOC",
		"function": "Function",
		"sports": "Sports",
		"allSports": "All sports",
		"noSport": "No sport",
		"meets": "Meets",
		"open": "Open {{name}}",
		"count_one": "{{n}} official",
		"count_other": "{{n}} officials"
	},
	"empty": {
		"filteredTitle": "No officials match these filters",
		"filteredBody": "Clear a filter, or reset them all to see every official.",
		"reset": "Reset filters",
		"noneTitle": "No technical officials in {{games}} yet",
		"noneBody": "An official appears here once their Technical Official card is approved in GMS.",
		"noGamesTitle": "No games are set up yet",
		"noGamesBody": "Games are created in GMS. Ask your administrator.",
		"forbiddenTitle": "Officials are not available to you"
	},
	"errors": {
		"gamesTitle": "The games could not load"
	},
	"detail": {
		"title": "Official",
		"loading": "Loading the official…",
		"errorTitle": "This official could not load",
		"close": "Close",
		"card": "Card no.",
		"noc": "NOC",
		"gender": "Gender",
		"function": "Function",
		"sports": "Sports",
		"assignments": {
			"title": "Meets",
			"none": "Not seated on any meet yet. Officials are added on each meet's screen.",
			"when": "When",
			"event": "Event",
			"meet": "Meet",
			"role": "Role",
			"position": "Seat",
			"unscheduled": "Not scheduled",
			"truncated": "Showing the first {{shown}} of {{total}} meets."
		}
	}
}
